// import { Button, Form, Switch } from 'antd';
// import React from 'react'
// import Modal from 'react-bootstrap/Modal';
// import { InputField } from '../../layouts/FormFields';

// const AddFaq = ({show,handleClose=()=>{}}) => {
//   return (
//     <>
//       {/* Modal for Show Partner Stores */}
//       <Modal show={show} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add FAQ Category</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form name='basic' autoComplete='off' className='row p-5 px-3 pb-1'>
//             <div className='row'>
//               <InputField
//                 col='col-12'
//                 rules={[
//                   {
//                     required: true,
//                     message: 'Enter Name',
//                   },
//                 ]}
//                 placeholder='FAQ Name'
//                 name='name'
//                 label='Name'
//                 required={true}
//                 // onKeyPress={handleKeysPress}
//               />
//               <InputField
//                 col='col-12'
//                 rules={[
//                   {
//                     required: true,
//                     message: 'Enter Index',
//                   },
//                 ]}
//                 placeholder='Index'
//                 name='index'
//                 label='Index'
//                 required={true}
//                 // onKeyPress={handleKeysPress}
//               />
//               <div className='col-lg-12 mb-2 ms-3'>
//                 <Form.Item label='Active' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
//                   <Switch
//                   // onChange={(e) => {
//                   //   console.log(e);
//                   //   setisActiv(e);
//                   // }}
//                   />
//                 </Form.Item>
//               </div>
//               <div className='d-flex align-items-center justify-content-center'>
//                 <button onClick={() => setUploadedImg('')} style={{ backgroundColor: 'rgb(242, 29, 47)' }} className='add-btn'>
//                   Add
//                 </button>
//               </div>
//             </div>
//           </Form>
//         </Modal.Body>
        
//       </Modal>
//     </>
//   );
// }

// export default AddFaq









import { Button, Form, message, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { InputField, SelectField, SelectFields } from '../../layouts/FormFields';
import axios from 'axios';
import getHeaders from '../../utils/authHeaders';
import LoaderImage from '../LoaderImage';
import { app } from '../../config';
import { LoadingOutlined } from '@ant-design/icons';

const AddFaq = ({ show, setShow, handleClose = () => {}, setisRender, loader, setLoader, parentElements }) => {
  const [form] = Form.useForm();
  // const [parentElements, setParentElemments] = useState([]);
  const [errorType, setErrorType] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const [parent, setparent] = useState('');
  const submit = async (values) => {
    try {
      let resp = await axios.post(`${app.URL}/api/v1/admin/faqcategory/create`, values, { headers: getHeaders() });
      // let resp = await axios.post(`http://localhost:3200/api/v1/admin/faqcategory/create`, values, { headers: getHeaders() });

      console.log(resp);
      if (resp.status == 200) {
        form.resetFields(); // Reset form fields after successful submission
        setLoader(true);

        setShow(false); // Close modal
        setisRender(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onFinish = (values) => {
    values.faqparentCategoryId = parent;
    console.log('Form Values:', values);
    if (!values.faqparentCategoryId) {
      setErrorMsg('Select a parent category');
      setErrorType('cat');
    }
    submit(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Form Submission Failed:', errorInfo);
  };
  // const getParents = async () => {
  //   try {
  //     let resp = await axios.get(`http://localhost:3200/api/v1/admin/faqparent/listing`);
  //     console.log('response', resp?.data?.result?.data);
  //     if (resp.status == 200) {
  //       setParentElemments(resp?.data?.result?.data);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   getParents();
  // }, []);
  const staticElements = [
    { faqparentCategoryId: 1, categoryName: 'Category 1' },
    { faqparentCategoryId: 2, categoryName: 'Category 2' },
  ];

  console.log('parentElements', parentElements);
  return (
    <>
      {loader && <LoaderImage />}
      {!loader && (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Add FAQ </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form
              form={form}
              name='basic'
              initialValues={{
                ['isActive']: 1,
              }}
              autoComplete='off'
              className='row  px-3 pb-1'
              onFinish={onFinish} // This will handle form submission
              onFinishFailed={onFinishFailed} // This will handle form validation failure
            >
              <div className='row'>
                {/* <div className='form-flo/ating'> */}
                <Form.Item
                  colon={false}
                  className=''
                  rules={[
                    { required: true, message: 'Please select a parent category.' }, // Validation rule to prevent empty submission
                  ]}
                >
                  <label for='floatingSelectGrid'>Parent Category</label>

                  <select
                    onChange={(e) => {
                      setparent(Number(e.target.value));
                      setErrorMsg('');
                      setErrorType('');
                    }}
                    rules={[
                      { required: true, message: 'Please select a parent category.' }, // Validation rule to prevent empty submission
                    ]}
                    value={parent}
                    // name='faqid'
                    className='form-select  col-8'
                    id='floatingSelectGrid'
                  >
                    <option value=''>
                      <span className='text-muted'> Open to select parent category</span>
                    </option>
                    Default option
                    {/* <option selected  >Open to select parent category</option> */}
                    {parentElements.map((item) => {
                      // console.log(!whatMeasuredData.some((data) => data.productWhatMeasuredId !== item.productWhatMeasuredId));

                      return <option value={item.faqparentCategoryId}>{item.categoryName}</option>;
                    })}
                  </select>
                  {errorType === 'cat' && <span className='ant-form-item-explain-error'>{errorMsg}</span>}
                </Form.Item>
                {/* </div> */}
                {/* <SelectField
                  col=' col-12'
                  name='faqparentCategoryId'
                  options={parentElements.map((item) => {
                    console.log('item', item);
                    return <Select.Option value={item.faqparentCategoryId}>{item.categoryName}</Select.Option>;
                  })}
                  rules={[
                    {
                      required: true,
                      message: 'Select Parent Category',
                    },
                  ]}
                  placeholder='Parent Category'
                  label='Parent Category'
                  required={true}
                  // onChange={(e) => handleContentDisplay(e)}

                  // return console.log("items",item)
                /> */}

                <InputField
                  col='col-12'
                  rules={[
                    {
                      required: true,
                      message: ' Enter Category Name',
                    },
                  ]}
                  placeholder='Category Name'
                  name='name'
                  label='Category Name'
                  required={true}
                />
                <InputField
                  pattern='^[0-9]*$'
                  col='col-12'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Index',
                    },
                  ]}
                  placeholder='Index'
                  name='index'
                  label='Index'
                  required={true}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <div className='col-lg-12 mb-2 ms-3'>
                  <Form.Item label='Active' className='selector-main' colon={false} valuePropName='checked' name='isActive'>
                    <Switch />
                  </Form.Item>
                </div>
                <div className='col-12'>
                  <div className='row justify-content-center'>
                    <button onClick={() => setShow(false)} htmlType='button' type='primary' className='btn btn-primary button patient-cancel-btn col-md-5 mr-2 mb-2'>
                      Cancel
                    </button>

                    <button disabled={loader} type='primary' class='btn btn-primary button col-md-5 mb-2' htmlType='submit'>
                      {loader ? <LoadingOutlined /> : 'Save'}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default AddFaq;
